import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=2003ec85&"
import script from "./Telephone.vue?vue&type=script&lang=js&"
export * from "./Telephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports